// ** React Imports
import { Fragment, useEffect, useState, memo } from "react"

// ** Third Party Components
import classnames from "classnames"
// import { useParams } from 'react-router-dom'
// ** Store & Actions
import { useSelector, useDispatch } from "react-redux"
import {
  handleContentWidth,
  handleMenuCollapsed,
  handleMenuHidden
} from "../../../../redux/layout"
import { useLocation } from 'react-router-dom'

// ** ThemeConfig
import themeConfig from "../../../../configs/themeConfig"

// ** Styles
// import { AnimatePresence } from "framer-motion/dist/framer-motion"
import "animate.css/animate.css"
import GlobalVariable from "../../../../settings/global"
const headerText = GlobalVariable.headerText

const LayoutWrapper = (props) => {
  // ** Props
  const { children, routeMeta } = props

  // ** Store Vars
  const dispatch = useDispatch()
  // const { catCode } = useParams()
  const store = useSelector((state) => state)

  const navbarStore = store.navbar
  const layoutStored = store.layout.layout
  const contentWidth = store.layout.contentWidth
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  const styles = windowWidth > 768 ? { height: '100%', marginRight: '-15px', marginTop: headerText ? '24px' : '2px', marginLeft: windowWidth <= 1200 ? "-18px" : store?.layout?.menuCollapsed ? '241px' : '241px', zIndex: '1', position: 'relative' } : {
    height: '100%', marginRight: '-6px', marginTop: headerText ? '24px' : '2px', marginLeft: windowWidth <= 1200 ? "-5px" : store?.layout?.menuCollapsed ? '241px' : '241px', zIndex: '1', position: 'relative'
  }
  //** Vars
  const appLayoutCondition =
    (layoutStored.layout === "horizontal" && !routeMeta) ||
    (layoutStored.layout === "horizontal" && routeMeta && !routeMeta.appLayout)
  const Tag = appLayoutCondition ? "div" : Fragment

  // ** Clean Up Function
  const cleanUp = () => {
    if (routeMeta) {
      if (
        routeMeta.contentWidth &&
        routeMeta.contentWidth === store.layout.contentWidth
      ) {
        dispatch(handleContentWidth(themeConfig.layout.contentWidth))
      }
      if (
        routeMeta.menuCollapsed &&
        routeMeta.menuCollapsed === store.layout.menuCollapsed
      ) {
        dispatch(handleMenuCollapsed(!store.layout.menuCollapsed))
      }
      if (
        routeMeta.menuHidden &&
        routeMeta.menuHidden === store.layout.menuHidden
      ) {
        dispatch(handleMenuHidden(!store.layout.menuHidden))
      }
    }
  }
  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener("resize", handleWindowWidth)
    }
  }, [windowWidth])
  const location = useLocation()
  function zIndexStyle() {
    if (location.pathname.split("/").includes("dashboard")) {
      return { overflow: "unset" }
    }
    return { overflow: "hidden" }
  }
  // ** ComponentDidMount
  useEffect(() => {
    if (routeMeta) {
      if (routeMeta.contentWidth) {
        dispatch(handleContentWidth(routeMeta.contentWidth))
      }
      if (routeMeta.menuCollapsed) {
        dispatch(handleMenuCollapsed(routeMeta.menuCollapsed))
      }
      if (routeMeta.menuHidden) {
        dispatch(handleMenuHidden(routeMeta.menuHidden))
      }
    }
    return () => cleanUp()
  }, [routeMeta])
  return (

    <div
      className={classnames("app-content content ", {
        [routeMeta ? routeMeta.className : ""]:
          routeMeta && routeMeta.className,
        "show-overlay": navbarStore.query.length
      })}
      style={zIndexStyle()}
    >
      <div className="content-overlay"></div>
      <div className="header-navbar-shadow" />
      <div
        className={classnames({
          "content-wrapper": routeMeta && !routeMeta.appLayout,
          "content-area-wrapper": routeMeta && routeMeta.appLayout,
          "pb-1": contentWidth === "boxed"
        })}
        // style={{ height: '100%', marginRight: '-48px', marginTop: catCode ? '-11px' : -11, marginLeft: catCode ? (store.layout.menuCollapsed === false ? '150px' : (store.layout.menuCollapsed === true ? '25px' : 0)) : (store.layout.menuCollapsed === false ? '150px' : (store.layout.menuCollapsed === true ? '25px' : 0)) }}
        style={styles}
      >
        <Tag {...(appLayoutCondition ? { className: "content-body" } : {})}>
          {children}
        </Tag>
      </div>
    </div>

  )
}

export default memo(LayoutWrapper)
